import {styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const NewAddressAddButton = styled(HoverElevationButton)(({theme}) => ({
    display: 'flex',
    flexDirection: 'row',
    padding: '0.5rem 0.75rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1.5rem',

    backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    color: theme.barekam.recipient.buttons.add.color,

    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    },

    '& img': {
        marginRight: '0.75rem'
    }
}));